var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _g4, _path7, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkiptraceCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "305.94 57.71 379.88 391.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a9154f10ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 402 57.710938 L 527 57.710938 L 527 216 L 402 216 Z M 402 57.710938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef747fabda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 305.953125 201 L 431 201 L 431 359 L 305.953125 359 Z M 305.953125 201 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f6c6b131b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 305.953125 57.710938 L 431 57.710938 L 431 215 L 305.953125 215 Z M 305.953125 57.710938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9bec812c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 478 345 L 561 345 L 561 449.019531 L 478 449.019531 Z M 478 345 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "73e438ec9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 541 346 L 624 346 L 624 449.019531 L 541 449.019531 Z M 541 346 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9154f10ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 412.574219 57.78125 C 414.910156 65.039062 415.105469 85.871094 427.796875 123.0625 C 435.027344 144.25 444.199219 159.523438 452.601562 169.726562 C 470.457031 191.402344 495.363281 203.359375 526.792969 205.53125 L 402.503906 215.53125 Z M 412.574219 57.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef747fabda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 420.15625 358.867188 C 417.816406 351.609375 417.625 330.78125 404.929688 293.585938 C 397.703125 272.398438 388.53125 257.125 380.125 246.921875 C 362.269531 225.246094 337.363281 213.289062 305.9375 211.117188 L 430.226562 201.121094 Z M 420.15625 358.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f6c6b131b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 412.5625 57.78125 C 410.589844 65.148438 411.449219 85.960938 400.648438 123.75 C 394.496094 145.273438 386.105469 160.988281 378.226562 171.601562 C 361.484375 194.152344 337.214844 207.351562 305.9375 211.101562 L 430.570312 214.820312 Z M 412.5625 57.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 420.167969 358.867188 C 422.136719 351.5 421.28125 330.6875 432.082031 292.902344 C 438.234375 271.378906 446.625 255.660156 454.503906 245.046875 C 471.242188 222.5 495.515625 209.296875 526.792969 205.546875 L 402.160156 201.828125 Z M 420.167969 358.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 612 61.335938 C 613.476562 66.125 613.429688 79.8125 621.457031 104.355469 C 626.03125 118.335938 631.929688 128.449219 637.367188 135.222656 C 648.921875 149.609375 665.183594 157.675781 685.816406 159.363281 L 604.070312 164.898438 Z M 612 61.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 614.476562 259.222656 C 613 254.4375 613.046875 240.746094 605.015625 216.203125 C 600.441406 202.222656 594.542969 192.113281 589.105469 185.339844 C 577.554688 170.949219 561.289062 162.882812 540.660156 161.195312 L 622.402344 155.660156 Z M 614.476562 259.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 611.992188 61.335938 C 610.636719 66.160156 611.027344 79.84375 603.613281 104.578125 C 599.394531 118.671875 593.75 128.925781 588.484375 135.835938 C 577.296875 150.511719 561.242188 158.980469 540.660156 161.1875 L 622.515625 164.667969 Z M 611.992188 61.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 614.484375 259.222656 C 615.839844 254.398438 615.449219 240.71875 622.859375 215.980469 C 627.082031 201.890625 632.722656 191.632812 637.988281 184.726562 C 649.175781 170.050781 665.234375 161.578125 685.816406 159.371094 L 603.957031 155.894531 Z M 614.484375 259.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 549.609375 251.445312 C 551.085938 256.234375 551.039062 269.921875 559.070312 294.464844 C 563.644531 308.445312 569.542969 318.558594 574.980469 325.332031 C 586.53125 339.722656 602.796875 347.789062 623.425781 349.476562 L 541.683594 355.011719 Z M 549.609375 251.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9bec812c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 552.085938 449.335938 C 550.609375 444.546875 550.65625 430.859375 542.628906 406.316406 C 538.054688 392.335938 532.15625 382.222656 526.71875 375.449219 C 515.164062 361.058594 498.902344 352.996094 478.269531 351.308594 L 560.015625 345.773438 Z M 552.085938 449.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 549.601562 251.449219 C 548.246094 256.269531 548.636719 269.953125 541.226562 294.691406 C 537.003906 308.78125 531.359375 319.039062 526.09375 325.945312 C 514.910156 340.621094 498.851562 349.09375 478.269531 351.296875 L 560.128906 354.777344 Z M 549.601562 251.449219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73e438ec9c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 552.09375 449.335938 C 553.449219 444.511719 553.058594 430.828125 560.472656 406.09375 C 564.691406 392 570.335938 381.746094 575.601562 374.835938 C 586.789062 360.160156 602.84375 351.691406 623.425781 349.484375 L 541.570312 346.003906 Z M 552.09375 449.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiptraceCropped);
export default __webpack_public_path__ + "static/media/skiptrace-cropped.ae6a2a5d7d7b006b939cba57cb69f238.svg";
export { ForwardRef as ReactComponent };